/**
 * PostHog event keys for document signatures page
 *
 * @example
 * ```ts
 * posthog.capture(POSTHOG_KEY.DOCUMENT_SIGNATURES_PAGE_GOTO_GOVERNMENT, {}):
 * ```
 */
export const POSTHOG_KEY = {
  DOCUMENT_SIGNATURES_PAGE_GOTO_GOVERNMENT:
    'DocumentSignaturesPageGotoGovernment',
  DOCUMENT_SIGNATURES_PAGE_GOTO_APP: 'DocumentSignaturesPageGotoApp',
};
